/// <reference path="../../app.definition.ts" />

import { Util } from "@common/util";
import { Serializable } from "./Serializable";

export class FormField implements Serializable<FormField> {
    key: string;
    id: string;
    type: string;
    fieldName: string;
    title: string;
    description: string;
    index: number;
    displayOptions: any;
    fieldOptions: any;
    answer: string;
    placeholder: string;
    required: boolean;
    sectionId: string;
    label: string;
    dependencies: any;
    uploadedDocs: Array<any>;
    roles: any;
    fields: Array<FormField>;
    htmlClass: string;
    fieldHtmlClass: string;

    constructor(input?: any) {
        !!input && (this.deserialize(input));
    }

    deserialize(input: any) {
        !!input.key && (this.key = input.key);
        !!input.id && (this.key = "field" + input.id);
        !!input.type && (this.type = input.type);
        !!input.fieldType && (this.type = input.fieldType);
        !!input.fieldName && (this.title = input.fieldName);
        !!input.title && (this.title = input.title);
        !!input.description && (this.description = input.description);
        !!input.index && (this.index = input.index);
        !!input.answer && (this.answer = input.answer);
        !!input.placeholder && (this.placeholder = input.placeholder);
        !!input.required && (this.required = input.required || false);
        !!input.sectionId && (this.sectionId = input.sectionId);
        !!input.label && (this.label = input.label);
        !!input.dependencies && (this.dependencies = input.dependencies);
        !!input.roles && (this.roles = input.roles);
        !!input.uploadedDocs && (this.uploadedDocs = input.uploadedDocs);
        if (!!input.jsonValue) {
            if (Util.isJsonString(input.jsonValue)) {
                this.fieldOptions = JSON.parse(input.jsonValue);
            } else {
                this.fieldOptions = input.jsonValue;
            }
        }
        !!input.fieldOptions && (this.fieldOptions = input.fieldOptions);
        Object.keys(this.fieldOptions).forEach(opts => {
            if (Util.isJsonString(this.fieldOptions[opts])) {
                this.fieldOptions[opts] = JSON.parse(this.fieldOptions[opts]);
            }
        });
        if (!!input.jsonDisplay) {
            if (Util.isJsonString(input.jsonDisplay)) {
                this.displayOptions = JSON.parse(input.jsonDisplay);
            } else {
                this.displayOptions = input.jsonDisplay;
            }
        }
        !!input.displayOptions && (this.displayOptions = input.displayOptions);
        if (!!this.displayOptions) {
            if (this.displayOptions.autoFill) {
                for (let autoFillEntity of this.displayOptions.autoFill) {
                    !!autoFillEntity.field && (autoFillEntity.sourceField = autoFillEntity.field);
                }
            }
            !!this.displayOptions.htmlClass && (this.htmlClass = this.displayOptions.htmlClass);
            !!this.displayOptions.fieldHtmlClass && (this.fieldHtmlClass = this.displayOptions.fieldHtmlClass);
        }
        let subFields;
        if (!!this.fieldOptions.fieldConfigurations && !!this.fieldOptions.fieldConfigurations.fields) {
            subFields = this.fieldOptions.fieldConfigurations.fields;
        } else if (!!input.fields) {
            subFields = input.fields;
        }
        if (!!subFields) {
            this.fields = [];
            for (let f of subFields) {
                this.fields.push(new FormField().deserialize(f));
            }
        }
        return this;
    }
}
